<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-19 14:06:00
 * @LastEditTime: 2023-02-11 09:06:01
 * @email: kongxiangyu@cd.baidu.com
 * @Description: 预售首页组件
-->
<template>
    <div class="page-wapper">
        <loading v-if="payLoading"/>
        <om-loading
            v-if="isLoading"
            :visable="isLoading"
            type="whole"
            theme="blue"
        />
        <mui-errorloading v-else-if="isError" @handleRetry="getMainData()"/>
        <div v-else class="wrap">
            <div class="top">
                <div
                    class="rule-icon"
                    :style="{
                        top: safeBarHeight + 'px',
                    }"
                >
                    <span @click="lookRules">规则</span> ｜ <span @click="nomalShare">分享</span>
                </div>
                <div
                    class="order-icon"
                    :style="{
                        top: safeBarHeight + 32 + 'px',
                    }"
                    @click="jumpToOrder"
                >订单中心</div>
            </div>
            <div class="countdown">
                <count-down
                    v-if="mainData"
                    :timestamp="mainData.activity_end_time *
                        1000 - new Date().getTime()"
                />
            </div>
            <dialog-box
                v-if="isShowDialogBox"
                :dialog-num="dialogNum"
                :is-show="isShow"
                :dialog-data="dialogData"
            />
            <packet v-if="getCouponList" :data-source="getCouponList"/>
            <today-sale
                v-if="getTodaySaleList"
                :data-source="getTodaySaleList"
                @pay="paySDK"
            />
            <hot
                v-if="getHotData"
                :data-source="getHotData"
            />
            <lunch
                v-if="getLunchData"
                :data-source="getLunchData"
            />
            <package
                v-if="isShowPackage"
                :popup-data="popupData"
                @close="handleClickPackage"
            />
            <float-btn
                :top="70"
                name="float-btn-package"
                :button-url="require('../../assets/package.png')"
                @handleClickFloatBtn="handleClickPackage"
            />
            <float-btn
                name="float-btn-ms"
                :top="79"
                :button-url="require('../../assets/miaosha.png')"
                @handleClickFloatBtn="jumpToMiaoSha"
            />
            <confirm-modal
                v-if="showConfirm"
                @onConfirm="onConfirm"
                @onCancel="onCancel"
            />
        </div>
    </div>
</template>
<script>
// 通用方法部分
import Server from '../../service.js';
import StatisticConst from '../../constant/StatisticConst.js';
import {homeShare} from '../../constant/ShareConfig.js';
import {getPlatInfo, getParamsFromUrl} from '@baidu/map-fe-utils';
import CountDown from './components/CountDown.vue';
import Packet from './components/Packet.vue';
import TodaySale from './components/TodaySale.vue';
import DialogBox from './components/dialog/DialogBox.vue';
import Package from './components/Package.vue';
import utils from '../../constant/utils.js';
import EventBus from '../../constant/EventBus.js';
import PollingRequest from '../../constant/pollingRequest';
import ConfirmModal from './components/ConfirmModal.vue';
import Loading from './components/Loading.vue';
import Lunch from './components/Lunch.vue';
import Hot from './components/Hot.vue';
import FloatBtn from './components/floatBtn.vue';
let top = 0;
export default {
    data() {
        return {
            isError: false,
            isLoading: true,
            // 所有数据
            isNative: getPlatInfo().isNative,
            safeBarHeight: 40,
            mainData: null,
            isShowDialogBox: false,
            isShowPackage: false,
            dialogNum: 1,
            isShow: false,
            dialogData: null,
            showConfirm: false,
            pollingRequest: new PollingRequest(this.getOrderDetail, 3000),
            orderDetailParams: null,
            payLoading: false,
            waitingForPayResultTimer: null,
            popupData: null
        };
    },
    components: {
        CountDown,
        Packet,
        Package,
        TodaySale,
        DialogBox,
        Lunch,
        Hot,
        ConfirmModal,
        Loading,
        FloatBtn
    },
    computed: {
        getCouponList() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'valentine-coupon';
            })[0] || null;
        },
        getTodaySaleList() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'valentine-pre-sale';
            })[0] || null;
        },
        getHotData() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'valentine-hot-product';
            })[0] || null;
        },
        getLunchData() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'valentine-lunch-product';
            })[0] || null;
        },
        getCoupons() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'sale_coupon_group';
            })[0] || null;
        },
        getListKey() {
            const data =  this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'tab_product_list';
            })[0].card_data.tab_product_list || '';
            if (data) {
                const res = {};
                data.forEach(item => {
                    if (item.tab_name === '饮品小吃') {
                        res.xc = item.product_option_id;
                    }
                    else if (item.tab_name === '聚会美食') {
                        res.zc = item.product_option_id;
                    }
                });
                return res;
            }
            return null;
        },
        getTplId() {
            return this.mainData && this.mainData.activity_frame.filter(item => {
                return item.tpl_name === 'tab_product_list';
            })[0].room_id || null;
        }
    },
    created() {
        if (!getPlatInfo().isNative) {
            this.isLoading = false;
            this.isShowDialogBox = true;
            StatisticConst.nativeOutShow();
            setTimeout(() => {
                this.isShow = true;
            }, 150);
            return;
        }
        StatisticConst.pageShow();
        this.getMainData();
        this.urlParams = getParamsFromUrl();
        if (this.urlParams.stbar_height) {
            this.safeBarHeight = parseInt(this.urlParams.stbar_height, 10);
        }
    },
    mounted() {
        EventBus.$on('refresh', this.getMainData);
        EventBus.$on('jointLogin', this.jumpToLogin);
        EventBus.$on('tplRefresh', this.tplRefresh);
        const urlWb = location.protocol + '//' + location.host + location.pathname + '?activity_id='
            + getParamsFromUrl().activity_id;
        homeShare(urlWb);
    },
    watch: {
        showConfirm: {
            handler(val) {
                this.stopScroll(val);
            },
            immediate: true
        }
    },
    methods: {
        tplRefresh(room_id = '0je9zqbw') {
            const params = {
                activity_id: getParamsFromUrl().activity_id,
                cuid: getParamsFromUrl().cuid,
                app_id: '20230206',
                room_id
            };
            // eslint-disable-next-line @babel/new-cap
            Server('TplRefresh', params)
                .then(res => {
                    try {
                        if (res.errno === 0) {
                            for (let i = 0; i < this.mainData.activity_frame.length; i++) {
                                if (this.mainData.activity_frame[i].room_id === room_id) {
                                    this.mainData.activity_frame[i].card_data = res.data.activity_frame[0].card_data;
                                }
                            }
                        }
                        else {
                            this.$toast(res.msg);
                        }
                    }
                    catch (e) {
                        console.error(e);
                        this.isError = true;
                    }
                })
                .catch(() => {
                    this.isError = true;
                    this.isLoading = false;
                });
        },
        jumpToLogin() {
            let cbUrl = location.protocol + '//' + location.host + location.pathname + location.search;
            const params = {
                navigationStatus: 2,
                hiddenTitle: 1,
                popRoot: 'yes',
                resetRoot: 'yes',
                mode: 'NORMAL_MODE',
                hideshare: 'yes',
                url: cbUrl
            };
            const url = 'baidumap://map/mnp?mode=NORMAL_MODE&popRoot=no&url=' + encodeURIComponent(
                'mapmnp://swan/AmnuKOLgt8NpGvGCp0Fx1HFsEvY2lOYc/packages/pepper/pages/login/index?bdvAuthority=map' + '&bdvPath=' + encodeURIComponent('/cost_share') + '&bdvParameters=' + encodeURIComponent(JSON.stringify(params)));
            window.location.href = url;
        },
        lookRules() {
            this.openDialogBox(2);
        },
        openDialogBox(n) {
            this.dialogNum = n;
            this.isShowDialogBox = true;
            setTimeout(() => {
                this.isShow = true;
            }, 150);
        },
        getMainData() {
            let params = {
                activity_id: getParamsFromUrl().activity_id,
                cuid: getParamsFromUrl().cuid,
                app_id: '20230206'
            };
            // eslint-disable-next-line @babel/new-cap
            Server('MainData', params)
                .then(res => {
                    try {
                        this.isLoading = false;
                        if (res && res.errno === 0) {
                            this.mainData = res.data;
                            const dialogData = res.data.activity_frame.filter(item => {
                                return item.tpl_name === 'valentine-dialog-coupon';
                            })[0];
                            this.dialogData = dialogData.card_data ? dialogData : null;
                            this.dialogData && this.openDialogBox(1);
                        }
                        else if (res && res.errno === 4000) {
                            this.jumpToLogin();
                        }
                        else {
                            this.$toast(res.msg);
                            this.isError = true;
                        }

                    }
                    catch (e) {
                        this.isError = true;
                    }
                })
                .catch(() => {
                    this.isError = true;
                    this.isLoading = false;
                });
        },
        /**
         * 接入SDK支付
         *
         * @param {Object} 订单信息 room_id、bdmap_coupon_ids、good_id
         */
        paySDK(coupon) {
            if (getPlatInfo().isNative) {
                const clientSv = window.yymap.nativeAppAdapter.phoneinfo.sv || '';
                if (!this.versionStringCompare(clientSv, '15.15.18')) {
                    this.$toast('百度地图app版本过低，请升级后重试～');
                    return;
                }
            }
            this.orderDetailParams = coupon;
            const cuid = getParamsFromUrl().cuid || '';
            const clientSv = getParamsFromUrl().sv || '';
            // 用户设备类型
            const clientFrom = getPlatInfo().isIos ? 1 : 2;
            const params = {
                ...coupon,
                activity_id: getParamsFromUrl().activity_id,
                app_id: '20230206',
                cuid,
                pay_type: 4,
                sdk: 1,
                clientSv,
                clientFrom,
                city_id: getParamsFromUrl().c || 0
            };
            // eslint-disable-next-line @babel/new-cap
            Server('OrderData', params)
                .then(res => {
                    if (res && res.errno === 0) {
                        const param = res.data;
                        utils.requestBdApi(`bdapi://walletPay?payParams=${encodeURIComponent(JSON.stringify(param))}`, {}, this.payCallback);
                    }
                    else {
                        this.$toast(res.msg);
                    }
                })
                .catch(e => {
                    console.error(e.message);
                });

        },
        /**
         * 支付回调
         */
        payCallback(e) {
            if (+e.suc === 0) {
                return;
            }
            this.checkPaymentStatus();
        },
        checkPaymentStatus() {
            this.pollingRequest.startPolling();
            this.stopPolling = false;
            this.waitingForPayResultTimer = setTimeout(() => {
                this.pollingRequest.stopPolling();
                this.showConfirm = true;
                this.payLoading = false;
                this.waitingForPayResultTimer = null;
            }, 15000);
        },
        /**
         * 查询订单结果
         */
        getOrderDetail() {
            this.payLoading = true;
            const params = {
                ...this.orderDetailParams,
                app_id: '20230206',
                activity_id: getParamsFromUrl().activity_id,
                cuid: getParamsFromUrl().cuid

            };
            // eslint-disable-next-line @babel/new-cap
            Server('GetOrderStatus', params)
                .then(res => {
                    if (res.errno === 0) {
                        if (res.data.status === 10) {
                            this.$toast('购买成功，可在订单中心查看详情～');
                            this.stop();
                            this.tplRefresh(params.room_id);
                        }
                        else if (res.data.status === 20) {
                            this.$toast('购买失败，已为您自动退款～');
                            this.stop();
                        }
                        else {
                            return;
                        }
                    }
                    else {
                        this.$toast(res.msg);
                    }
                })
                .catch(e => {
                    console.error(e.message);
                });
        },
        /**
         * 版本判断
         *
         * @param {String} preVersion 当前版本
         * @param {String} lastVersion 比较版本
         * @return 是否高于比较版本
         */
        versionStringCompare(preVersion = '', lastVersion = '') {
            let sources = preVersion.split('.');
            let dests = lastVersion.split('.');
            let maxL = Math.max(sources.length, dests.length);
            let result = true;
            for (let i = 0; i < maxL; i++) {
                let preValue = sources.length > i ? sources[i] : 0;
                let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
                let lastValue = dests.length > i ? dests[i] : 0;
                let lastNum =  isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
                if (preNum < lastNum) {
                    result = false;
                    break;
                }
                else if (preNum > lastNum) {
                    result = true;
                    break;
                }
            }
            return result;
        },
        stop() {
            this.pollingRequest.stopPolling();
            this.payLoading = false;
            clearTimeout(this.waitingForPayResultTimer);
        },
        onConfirm() {
            this.showConfirm = false;
            this.checkPaymentStatus();
        },
        onCancel() {
            this.$toast('发券失败，退款即将到账');
            this.showConfirm = false;
        },
        closeDialogBox() {
            this.isShowDialogBox = false;
            this.isShow = false;
        },
        handleClickPackage() {
            StatisticConst.myPackage();
            this.isShowPackage = !this.isShowPackage;
        },
        nomalShare() {
            StatisticConst.share();
            window.yymap.naa.openShare();
        },
        /**
         * 阻止页面滚动，用于弹窗开启
         */
        stopScroll(isFixed) {
            const bodyEl = document.body;
            if (isFixed) {
                top = window.scrollY;
                bodyEl.style.position = 'fixed';
                bodyEl.style.top = -top + 'px';
            }
            else {
                bodyEl.style.position = '';
                bodyEl.style.top = '';

                window.scrollTo(0, top); // 回到原先的top
            }
        },
        jumpToOrder() {
            StatisticConst.order();
            // 线上
            window.location.href = 'baidumap://map/cost_share?hideshare=yes&hiddenTitle=1&hiddenBackBtn=1&popRoot=no&url=https%3A%2F%2Fcarowner.baidu.com%2ForderCenter%2Forder.html%3Ffr%3DPersonalCenter';
            // 测试环境
            // window.location.href = 'baidumap://map/cost_share?hideshare=yes&hiddenTitle=1&hiddenBackBtn=1&popRoot=no&url=http://hexiaoxiang.bcc-szth.baidu.com:8766/orderCenter/order.html?forceapi=yuemei';

        },
        jumpToMiaoSha() {
            StatisticConst.miaosha();
            window.location.href = 'baidumap://map/cost_share?navigationStatus=2&popRoot=no&hiddenTitle=1&url=https%3A%2F%2Fscenes.map.baidu.com%2Fstatic%2Fsubpages%2Ffood-static%2Ffood-static.html%3Factivity_id%3D03hp07h6000eqg23ec08%26fr%3Dqingrenjie';
        }
    }
};
</script>
<style lang="scss" scoped>
.page-wapper {
    width: 100vw;
    min-height: 100vh;
    background:#c60727;
    .wrap{
        padding-bottom:30px;

        .top{
            width:100%;
            height:251px;
            background-image: url('../../assets/top.png');
            background-size: 100% 100%;
            position:relative;
            // .share-icon {
            //     background-image: url('../../assets/share-icon.png');
            //     width: 60px;
            //     height: 22px;
            //     background-size: 100% 100%;
            //     position: absolute;
            //     right: 0px;
            //     top: 78px;
            // }

            .rule-icon {
                border-radius:11px;
                color:white;
                width: 84px;
                height: 22px;
                display:flex;
                align-items:center;
                justify-content: center;
                background-size: 100% 100%;
                position: absolute;
                right: 8px;
                // top: 78px;
                background: rgba(0,0,0,.5);
                span{
                    display: block;
                }
            }
            .order-icon{
                border-radius:11px;
                color:white;
                display:flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 22px;
                background-size: 100% 100%;
                position: absolute;
                right: 8px;
                // top: 110px;
                background: rgba(0,0,0,.5);
            }
            .packetTop{
                width:calc(100% - 11px);
                height:22px;
                background-image: url('../../assets/countdown.png');
                background-size: 100% 100%;
                position: absolute;
                bottom:-1px;
                left:5.5px;
            }
        }
        .countdown{
            width:calc(100% - 10px);
            margin:0 auto;
            height:54px;
            background-image: url('../../assets/countdown.png');
            background-size: 100% 100%;
        }
        .package{
            width:50px;
            height: 50px;
            position:fixed;
            right:0;
            top:310px;
            z-index:1;
        }
        .order{
            width:50px;
            height: 50px;
            position:fixed;
            right:0;
            top:430px;
            z-index:1;
        }
        .miaosha{
            width:50px;
            height: 50px;
            position:fixed;
            right:0;
            top:370px;
            z-index:1;
        }
    }

}

</style>
